<template>
  <div>
    <div class="handle-box">
      <el-input
        size="small"
        placeholder="请输入承诺标题或发起人"
        v-model.trim="searchName"
        class="handle-input mr10"
      ></el-input>
      <el-select
        class="mr10"
        clearable
        v-model="type"
        placeholder="请选择"
        size="small"
      >
        <el-option
          v-for="item in typeOption"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select
        class="mr10"
        clearable
        v-model="status"
        placeholder="请选择"
        size="small"
      >
        <el-option
          v-for="item in statusOption"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="getData(1)"
        size="small"
        >搜索</el-button
      >
    </div>

    <el-table
      :data="data.records"
      border
      class="table"
      ref="multipleTable"
      header-cell-class-name="table-header"
    >
      <el-table-column header-align="center" prop="name" label="承诺标题">
      </el-table-column>
      <el-table-column
        prop="targetName"
        align="center"
        label="发起人"
      ></el-table-column>
      <el-table-column align="center" label="发布时间" width="180px">
        <template #default="scope">
          {{ $utils.formatDate(scope.row.time, "yyyy-MM-dd hh:mm") }}
        </template>
      </el-table-column>
      <el-table-column label="承诺类型" align="center" :formatter="dataType">
      </el-table-column>
      <el-table-column label="承诺详情" align="center">
        <template #default="scope">
          <el-button size="mini" type="primary" @click="info(scope.row)"
            >承诺详情</el-button
          >
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" align="center">
        <template #default="scope">
          <el-button
            type="success"
            size="mini"
            v-if="scope.row.auditStatus === 1"
            @click="handleEdit(scope.row, 3)"
            >禁止展示</el-button
          >
          <el-button
            type="warning"
            size="mini"
            v-if="scope.row.auditStatus === 3"
            @click="handleEdit(scope.row, 4)"
            >恢复展示</el-button
          >
          <el-button type="danger" size="mini" @click="delData(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :current-page="data.current"
        :page-size="20"
        :total="data.total"
        @current-change="getData"
      ></el-pagination>
    </div>

    <!-- 详情 -->
    <el-dialog
      title="承诺详情"
      v-model="dialogVisible"
      width="1000px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="event_wrap">
        <el-form size="mini" inline>
          <div>
            <el-form-item>{{ itemData.name }}</el-form-item>
          </div>
          <div>
            <el-form-item>{{ itemData.targetName }}</el-form-item>
          </div>
          <div>
            <el-form-item
              >{{ $utils.formatDate(itemData.startTime, "yyyy-MM-dd hh:mm") }}~
              {{
                $utils.formatDate(itemData.endTime, "yyyy-MM-dd hh:mm")
              }}</el-form-item
            >
          </div>
          <div>
            <el-form-item label="公开展示：">{{
              dataType(itemData)
            }}</el-form-item>
          </div>
          <div>
            <el-form-item label="是否允许个人加入：">{{ itemData.xinfuPersonJoin?'是':'否' }}</el-form-item>
          </div>
          <div v-if="itemData.type === 2">
            <el-form-item label="信用条件：">
              <div>
                <li v-for="item in itemData.certificationYear" :key="item">
                  {{ item }}年诚信认证
                </li>
                <li v-if="itemData.assess > 0">
                  信夫{{ assess(itemData) }}:{{
                    assessScore(itemData.assessScore)
                  }}
                </li>
                <li v-if="itemData.xinfuPersonJoin">
                  个人信夫{{itemData.xinfuPersonChoose===1?'信贷分':'职信分'}}：{{assessScore(itemData.xinfuPersonScore)}}
                </li>
              </div>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="声明：">{{ itemData.statement }}</el-form-item>
          </div>
          <div>
            <el-form-item label="承诺内容：">{{
              itemData.content
            }}</el-form-item>
          </div>
        </el-form>

        <el-table
          :data="listData.records"
          border
          class="table"
          ref="multipleTable"
          header-cell-class-name="table-header"
        >
          <el-table-column prop="userName" label="用户名称"></el-table-column>
          <el-table-column
            label="用户类型"
            align="center"
            :formatter="dataTargetType"
            v-if="itemData.type === 2"
          >
          </el-table-column>

          <el-table-column align="center" label="发布时间" min-width="180px">
            <template #default="scope">
              {{ $utils.formatDate(scope.row.auditTime, "yyyy-MM-dd hh:mm") }}
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination
            background
            layout="total, prev, pager, next"
            :current-page="listData.current"
            :page-size="10"
            :total="listData.total"
            @current-change="getInfo"
          ></el-pagination>
        </div>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="dialogVisible = false"
            >关闭</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
      searchName: "",
      status: "",
      type: "",
      typeOption: [
        { label: "全部", value: "" },
        { label: "内部承诺", value: 1 },
        { label: "社会承诺", value: 2 },
      ],
      statusOption: [
        { label: "全部", value: "" },
        { label: "审核通过", value: 1 },
        { label: "禁止展示", value: 3 },
      ],
      dialogVisible: false,
      itemData: {},
      listData: {},
    };
  },
  methods: {
    async getData(page = 1) {
      if (this.searchName.length > 30) {
        this.$message.warning("搜索内容最多输入30个字");
        return;
      }
      const params = {
        name: this.searchName,
        type: this.type,
        status: this.status,
        currentPage: page,
        pageSize: 20,
      };
      try {
        this.$loading.start();
        const res = await this.$api.promise.list.getData(params);
        this.$loading.done();
        if (res.code === 10200) {
          this.data = res.data;
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        this.$loading.done();
      }
    },
    dataType(data) {
      switch (data.type) {
        case 1:
          return "内部承诺";
        case 2:
          return "社会承诺";
        default:
          return "-";
      }
    },
    assess(data) {
      switch (data.assess) {
        case 1:
          return "履约分";
        case 2:
          return "信贷分";
        case 3:
          return "综合分";
        default:
          return "-";
      }
    },
    assessScore(val) {
      switch (val) {
        case 1:
          return "200分以上";
        case 2:
          return "400分以上";
        case 3:
          return "600分以上";
        case 4:
          return "800分以上";
        default:
          return "-";
      }
    },
    dataTargetType(data) {
      switch (data.targetType) {
        case 1:
          return "个人承诺";
        case 2:
          return "企业承诺";
        case 3:
          return "团体承诺";
      }
    },
    handleEdit(data, status) {
      if (!this.loading) {
        const text = status === 4 ? "是否确认恢复?" : "是否确认禁止展示?";
        this.$confirm(text, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            try {
              this.loading = true;
              this.$loading.start();
              const params = {
                id: data.id,
                targetType: data.targetType,
                type: data.type,
                status: status,
              };
              const res = await this.$api.promise.review.setData(params);
              this.loading = false;
              this.$loading.done();
              if (res.code === 10200) {
                this.getData(this.data.current);
                this.$message.success("操作成功！");
              } else {
                this.$message.error(res.msg);
              }
            } catch (error) {
              this.loading = false;
              this.$loading.done();
            }
          })
          .catch(() => {});
      }
    },
    // 删除
    delData(data) {
      this.$confirm("是否确认删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          try {
            this.loading = true;
            this.$loading.start();
            const params = {
              id: data.id,
              targetType: data.targetType,
              type: data.type,
            };
            const res = await this.$api.promise.list.delData(params);
            this.loading = false;
            this.$loading.done();
            if (res.code === 10200) {
              this.getData(this.data.current);
              this.$message.success("删除成功");
            } else {
              this.$message.error(res.msg);
            }
          } catch (error) {
            this.loading = false;
            this.$loading.done();
          }
        })
        .catch(() => {});
    },
    async info(data) {
      this.itemData = { ...data };
      this.itemData.certificationYear = data.certificationYear
        ? data.certificationYear.split(",")
        : [];
      await this.getInfo();
      this.dialogVisible = true;
    },
    async getInfo(page = 1) {
      if (!this.loading) {
        this.loading = true;
        this.$loading.start();
        const params = {
          id: this.itemData.id,
          targetType: this.itemData.targetType,
          type: this.itemData.type,
          currentPage: page,
          pageSize: 10,
        };
        const res = await this.$api.promise.list.getInfo(params);
        this.loading = false;
        this.$loading.done();
        if (res.code === 10200) {
          this.listData = res.data;
        } else {
          this.$message.error(res.msg);
        }
      }
    },
  },
  created() {
    this.getData();
  },
  computed: {
    region() {
      return this.$utils.getRegion();
    },
  },
  watch: {
    province: {
      handler(val, ovl) {
        this.region.forEach((item) => {
          if (item.label === val) {
            this.cityList = item.children;
          }
        });
      },
    },
    city: {
      handler(val, ovl) {
        this.cityList.forEach((item) => {
          if (item.label === val) {
            this.areaList = item.children;
          }
        });
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.handle-input {
  width: 200px;
  display: inline-block;
}

.handle-box {
  margin-bottom: 20px;

  .el-select {
    width: 180px;
  }
}

.cover {
  width: 160px;
  height: 90px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.status {
  height: 90px;
  line-height: 90px;
  position: relative;
  .prohibit {
    left: 0;
    width: 100%;
    display: inline-block;
    position: absolute;
    color: #fa6164;
    font-size: 1.5rem;
    transform: rotate(30deg);
  }
}

.event_wrap {
  .cover-title {
    display: flex;

    .cover {
      margin-right: 24px;
    }

    .title-name {
      li {
        line-height: 26px;
      }
    }
  }

  .time-status {
    padding-top: 24px;
    li {
      line-height: 26px;

      span {
        margin-left: 50px;
      }
    }
  }

  .title {
    margin: 24px 0;
    padding-left: 10px;
    font-size: 1.125rem;
    border-left: 2px solid #409eff;
  }

  .el-form-item {
    margin-bottom: 0;
  }

  .credit {
    display: flex;
    margin-bottom: 24px;
    span {
      line-height: 32px;
      font-size: 0.875rem;
    }
    .value {
      color: #666666;
    }
  }
}
</style>